/**
 * Siège de douche
 */
import CustomObject from '../CustomObject.js'

export default class ShowerSeat extends CustomObject
{
    constructor(modelPath, position, id, rotation) {
        super(modelPath, position, id, rotation);
        this.type = "showerSeat";
        this.position.y = 0.08;
        this.collisionAllowed = true;
        this.snappingAllowed = false;
        this.axesMove = [true, false, true]; // x, y
    }
}